// extracted by mini-css-extract-plugin
export default {"wholeContent":"SideNavPage_wholeContent__Fx3vh","rhs":"SideNavPage_rhs__AnfYP","toastMessages":"SideNavPage_toastMessages__SSYEE"};